function NotAuthorizedPage() {
  return (
    <>
      <h1>Not Authorized</h1>
    </>
  );
}

export default NotAuthorizedPage;
